/**
 * OIDC Client Wrapper for Login UI
 *
 * Uses the shared @agion/oidc-client for production OIDC flows
 */

import { createOIDCClient } from '@agion/oidc-client'
import { config } from '@/utils/config'

/**
 * Shared OIDC client instance
 * Uses auth-service as the OIDC authority for all OIDC endpoints
 */
export const oidcClient = createOIDCClient(
  config.authAuthority,  // https://auth.agion.dev (for authorization and token exchange)
  'login-ui',            // client_id
  config.authAuthority   // https://auth.agion.dev (token endpoint must be on same domain as auth endpoint)
)
